import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
    private readonly baseUrl = `${environment.base_url}/reports`;
  

  constructor(private http: HttpClient) {}

  gerarPdf(saleId: number): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/print-a4?entityId=${saleId}`, null, { responseType: 'blob' });
  }


  
}
